export default __webpack_public_path__ + "static/media/ninja.969cd1b0.png";